export const BREADCRUMBS_SET = 'BREADCRUMBS_SET'
export const BREADCRUMBS_CLEAR = 'BREADCRUMBS_CLEAR'
